import { useTranslation } from "react-i18next";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./InfoBox.scss";

interface IInfoBoxProps {
  icon: IconProp;
  infoTranslationKey: string;
}

export const InfoBox = (props: IInfoBoxProps) => {
  const { t } = useTranslation();

  return (
    <div className="info-box">
      <FontAwesomeIcon icon={props.icon} />

      {t(props.infoTranslationKey)}
    </div>
  );
};
